
<template>
    <form class="form m-3 mt-4" @submit.prevent="handleSubmit">
        <h4>Add User to Account</h4>
        <hr>
        <label class="d-block">
            Email
            <input type="email" class="form-control" v-model="email" required/>
        </label>
        <label class="d-block">
            User Role
            <select class="form-control form-select" v-model="role" required>
                <option value="">Select a role...</option>
                <option value="reviewer">Reviewer</option>
                <option value="editor">Editor</option>
                <option value="manager">Manager</option>
                <option value="administrator">Administrator</option>
            </select>
        </label>
        <label class="d-block">
            Account ID
            <input type="text" class="form-control" v-model="account_id" required/>
        </label>
        <div class="mb-3">
            <button type="button" class="btn btn-secondary" @click="checkAccountName" :disabled="!account_id || isCheckingAccount">
                {{ isCheckingAccount ? 'Checking...' : 'Check Account Name' }}
            </button>
            <span v-if="accountName" class="ms-2 text-success">
                {{ accountName }}
            </span>
            <span v-if="accountCheckError" class="ms-2 text-danger">
                {{ accountCheckError }}
            </span>
        </div>
        <button type="submit" class="btn btn-primary full-width" :disabled="isSubmitting">
            {{ isSubmitting ? 'Adding...' : 'Add' }}
        </button>

        <div v-if="errorMessage" class="meter-warning alert alert-danger mt-3">
            {{ errorMessage }}
        </div>
    </form>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const email = ref('');
const role = ref('');
const account_id = ref('');
const isSubmitting = ref(false);
const errorMessage = ref('');
const isCheckingAccount = ref(false);
const accountName = ref('');
const accountCheckError = ref('');

const checkAccountName = async () => {
    if (!account_id.value) {
        return;
    }

    isCheckingAccount.value = true;
    accountName.value = '';
    accountCheckError.value = '';

    try {
        const response = await (window as any).$app.api.get(`/accounts/${account_id.value}`);
        accountName.value = response.data.name || 'No name available';
    } catch (error) {
        console.error('Error fetching account:', error);
        accountCheckError.value = 'Account not found';
    } finally {
        isCheckingAccount.value = false;
    }
};

const handleSubmit = async () => {
    isSubmitting.value = true;
    errorMessage.value = '';

    try {
        const payload = {
            email: email.value,
            role: role.value,
        };

        await (window as any).$app.api.post(`/internal/accounts/${account_id.value}/users`, payload);

        // Clear form on success
        email.value = '';
        role.value = '';
        account_id.value = '';
        accountName.value = '';
        accountCheckError.value = '';

        alert('User added successfully!');
    } catch (error) {
        console.error('Error adding user to account:', error);

        if (error.response?.data?.exception) {
            errorMessage.value = error.response.data.exception;
        } else if (error.response?.data?.description) {
            errorMessage.value = error.response.data.description;
        } else if (error.message) {
            errorMessage.value = error.message;
        } else {
            errorMessage.value = 'Failed to add user to account. Please try again.';
        }
    } finally {
        isSubmitting.value = false;
    }
};
</script>
